/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const mainVisSwiper = () => {
		const splide = new Splide('.js-top-mainVis.splide', {
			type: 'fade',
			rewind: true,
			autoplay: true,
			interval: 5000, // 自動再生の間隔
			speed: 2000, // スライダーの移動時間
			perPage: 1,
			perMove: 1,
			pauseOnHover: false,
			pauseOnFocus: false,
			arrows: true,
			pagination: false,
			paginationKeyboard: true,
			classes: {
				arrows: 'splide__arrows mod-slider-arrows',
				arrow: 'splide__arrow mod-slider-arrow',
				prev: 'splide__arrow--prev mod-slider-prev',
				next: 'splide__arrow--next mod-slider-next'
			},
		});
		function slideIndex() {
			const current = String(splide.index + 1).padStart(2, '0');
			const total = String(splide.Components.Slides.getLength()).padStart(2, '0');
			const currentElement = document.querySelector('.slide-current');
			const lengthElement = document.querySelector('.slide-length');
			if (currentElement) currentElement.textContent = current;
			if (lengthElement) lengthElement.textContent = total;
		}
		splide.on('moved', slideIndex);
		splide.mount();
		slideIndex();
		// スライドが1枚のみの場合、コントロールを削除
		if (splide.Components.Slides.getLength() === 1) {
			const controls = document.querySelector('.top-mainVis-slider .mod-slider-controls');
			if (controls) {
				controls.remove();
			}
		}
	};

	const aboutAnimation = () => {
		const $about = document.querySelector('.js-top-about');
		const $head = document.querySelector('.js-top-about-head');
		const $ilItems = document.querySelectorAll('.js-top-about-il');

		if (!$about || !$head || !$ilItems.length) return;

		$about.classList.add('is-animSet');

		const options = {
			root: null,
			rootMargin: '-300px 0px',
			threshold: 0.01
		};
		const callback = (entries, observer) => {
			entries.forEach(entry => {
				const visible = entry.isIntersecting || entry.intersectionRatio > 0;
				if (!visible) return;
				// Fisher-Yates シャッフル
				const ilArray = Array.from($ilItems);
				for (let i = ilArray.length - 1; i > 0; i--) {
					const j = Math.floor(Math.random() * (i + 1));
					[ilArray[i], ilArray[j]] = [ilArray[j], ilArray[i]];
				}
				// 3 グループに分割
				const totalItems = ilArray.length;
				const groupSize = Math.ceil(totalItems / 3);
				const groups = [];
				for (let i = 0; i < 3; i++) {
					const start = i * groupSize;
					const end = Math.min(start + groupSize, totalItems);
					groups.push(ilArray.slice(start, end));
				}
				// グループごとに is-active を付与
				groups.forEach((group, groupIndex) => {
					setTimeout(() => {
						group.forEach(item => {
							item.classList.add(a);
						});
						if (groupIndex === groups.length - 1) {
							setTimeout(() => {
								$head.classList.add(a);
							}, 800);
						}
					}, groupIndex * 500);
				});
				observer.unobserve(entry.target);
			});
		};
		const observer = new IntersectionObserver(callback, options);
		observer.observe($about);
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		mainVisSwiper();
		aboutAnimation();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
